import ExampleSaveButton from '../example-buttons/ExampleSaveButton.vue';
import ExampleCloseButton from '../example-buttons/ExampleCloseButton.vue';
import ExampleDeleteButton from '../example-buttons/ExampleDeleteButton.vue';

# Asset Dialog

## <v-icon>mdi-rename-box</v-icon> Rename

Rename your Asset, and see a preview of it.

Note: Preview only works for Images, Video and Live Streams.

## <v-icon>mdi-tag</v-icon> Manage Tags

Select all the Tags you would like to assign to this Asset.

## <v-icon>mdi-broom</v-icon> Asset Expiry

Enter a date that the Asset will Expire in format dd/mm/yyyy.

## <v-icon>mdi-information</v-icon> Asset Info

If CanvasPro can detect meta data for the asset then it will be shown here.

Note: Only supports Images and Videos.

## Delete

Note: This will delete the asset without a confirmation dialog box.

Click <v-btn><v-icon>mdi-trash-can</v-icon></v-btn> to delete the asset.

## Download

Click <v-btn><v-icon>mdi-tray-arrow-down</v-icon></v-btn> to download the asset to your device.

## Save

Once you've saved your changes, click <ExampleSaveButton /> (bottom right).

To cancel your changes, click <ExampleCloseButton /> (top right).
